// 行情配置
export const market = {

  // 普通 指数字典
  indexList: [
    { name: '上证指数', code: '000001' },
    { name: '深证指数', code: '399001' },
    { name: '创业板指', code: '399006' },
    { name: '沪深300', code: '000300' },
    { name: '中小板指', code: '399005' },
    { name: '中证500', code: '000905' },
    { name: '上证50', code: '000016' },
  ],
  // 债券 指数字典
  zqindexList: [
    { name: '国债指数', code: '000012' },
    { name: '上证指数', code: '000001' },
    { name: '深证指数', code: '399001' },
    { name: '创业板指', code: '399006' },
    { name: '沪深300', code: '000300' },
    { name: '中小板指', code: '399005' },
    { name: '中证500', code: '000905' },
    { name: '上证50', code: '000016' },
  ],
  hkindexList: [
  ],
  // 时间字典
  hktimeList: [
    { name: '近1月', code: 'y', track: 'm' },
    { name: '近3月', code: '3y', track: 'q' },
    { name: '近6月', code: '6y', track: 'hy' },
    { name: '近1年', code: 'n', track: '1y' },
  ],
  // 时间字典
  timeList: [
    { name: '近1月', code: 'y', track: 'm' },
    { name: '近3月', code: '3y', track: 'q' },
    { name: '近6月', code: '6y', track: 'hy' },
    { name: '近1年', code: 'n', track: '1y' },
    { name: '近3年', code: '3n', track: '3y' },
    { name: '近5年', code: '5n', track: '5y' },
    { name: '今年来', code: 'jn', track: 'jn' },
    { name: '成立来', code: 'ln', track: 'cl' },
  ],

  // 不需要选择时间区间的类型
  withoutTimeList: ['分时', '日K', '周K', '月K'],

  type: {

    // 普通基金
    normal: {
      // 图表实例集合
      chartList: [
        {
          name: '累计收益', id: 'canvas_total_revenue', f2: null, track: 'ljsy',
        },
        {
          name: '单位净值', id: 'canvas_unit_net', f2: null, track: 'dwjz',
        },
        {
          name: '累计净值', id: 'canvas_total_net', f2: null, track: 'ljjz',
        },
      ],
    },
    // 普通基金
    hk: {
      // 图表实例集合
      chartList: [
        {
          name: '累计收益', id: 'canvas_total_revenue', f2: null, track: 'ljsy',
        },
        {
          name: '单位净值', id: 'canvas_unit_net', f2: null, track: 'dwjz',
        },
      ],
    },

    // 普通基金(退市)
    normalts: {
      // 图表实例集合
      chartList: [
        {
          name: '累计收益', id: 'canvas_total_revenue', f2: null, track: 'ljsy',
        },
        {
          name: '单位净值', id: 'canvas_unit_net', f2: null, track: 'dwjz',
        },
        {
          name: '累计净值', id: 'canvas_total_net', f2: null, track: 'ljjz',
        },
      ],
    },

    // 净值型货币和净值型理财基金
    jz: {
      // 图表实例集合
      chartList: [
        {
          name: '累计收益', id: 'canvas_total_revenue', f2: null, track: 'ljsy',
        },
        {
          name: '单位净值', id: 'canvas_unit_net', f2: null, track: 'dwjz',
        },
        {
          name: '累计净值', id: 'canvas_total_net', f2: null, track: 'ljjz',
        },
      ],
    },

    // 黄金基金
    gold: {
      // 图表实例集合
      chartList: [
        {
          name: '累计收益', id: 'canvas_total_revenue', f2: null, track: 'ljsy',
        },
        {
          name: '单位净值', id: 'canvas_unit_net', f2: null, track: 'dwjz',
        },
        {
          name: '累计净值', id: 'canvas_total_net', f2: null, track: 'ljjz',
        },
        {
          name: '金价走势', id: 'canvas_gold', f2: null, track: 'jjzs',
        },
      ],
    },
    // 横屏黄金基金
    goldhp: {
      // 图表实例集合
      chartList: [
        {
          name: '累计收益', id: 'canvas_total_revenue', f2: null, track: 'ljsy',
        },
        {
          name: '单位净值', id: 'canvas_unit_net', f2: null, track: 'dwjz',
        },
        {
          name: '累计净值', id: 'canvas_total_net', f2: null, track: 'ljjz',
        },
        {
          name: '金价走势', id: 'canvas_gold', f2: null, track: 'jjzs',
        },
      ],
    },
    // 货币基金
    hb: {
      // 图表实例集合
      chartList: [
        {
          name: '万元收益', id: 'canvas_hb_ten_thousand_share_profit', f2: null, track: 'wfsy',
        },
        {
          name: '7日年化', id: 'canvas_hb_seven_day_profit', f2: null, track: 'qrnh',
        },
      ],
    },

    // 场内基金
    onSite: {
      // 图表实例集合
      chartList: [
        {
          name: '分时', id: 'canvas_on_site_dt', f2: null, track: 'fs',
        },
        {
          name: '日K', id: 'canvas_on_site_dk', f2: null, track: 'dk',
        },
        {
          name: '周K', id: 'canvas_on_site_wk', f2: null, track: 'wk',
        },
        {
          name: '月K', id: 'canvas_on_site_mk', f2: null, track: 'mk',
        },
        {
          name: '净值', id: 'canvas_unit_net', f2: null, track: 'cnjz',
        },
      ],
    },

    // FOF基金
    fof: {
      // 图表实例集合
      chartList: [
        {
          name: '累计收益', id: 'canvas_total_revenue', f2: null, track: 'ljsy',
        },
        {
          name: '单位净值', id: 'canvas_unit_net', f2: null, track: 'dwjz',
        },
        {
          name: '累计净值', id: 'canvas_total_net', f2: null, track: 'ljjz',
        },
      ],
    },
  },

  // 走势曲线颜色
  // colors: ['rgba(255,68,0,1)', 'rgba(153,153,153,1)', 'rgba(0,138,255,1)', 'rgba(255,0,0,1)'],
  colors: ['rgba(255,68,0,1)', 'rgba(153,153,153,1)', 'rgba(0,138,255,1)', 'rgba(255,216,103,1)'],
  colorsnoyj: ['rgba(255,68,0,1)', 'rgba(153,153,153,1)', 'rgba(0,138,255,1)'],
  colorshk: ['rgba(153,153,153,1)', 'rgba(255,68,0,1)', 'rgba(0,138,255,1)'],

  // 7日年化
  colors7: ['rgba(0,138,255,1)', 'rgba(255,68,0,1)'],

  // 净值估算配置
  stockAxis: {
    // 港股
    HK: {
      // 时间轴点数
      count: 330,
      // 开始时间
      startTime: '09:30',
      // 数据数组
      data: [],
      // 结束时间
      endTime: '16:00',
    },
    // 美股(夏令时)
    USASummer: {
      // 时间轴点数
      count: 390,
      // 开始时间
      startTime: '21:30',
      // 结束时间
      endTime: '04:00',
    },
    // 美股(冬令时)
    // eslint-disable-next-line no-dupe-keys
    USAWinter: {
      // 时间轴点数
      count: 390,
      // 开始时间
      startTime: '22:30',
      // 结束时间
      endTime: '05:00',
    },
    // 国内股
    CN: {
      // 时间轴点数
      count: 240,
      // 开始时间
      startTime: '09:30',
      // 结束时间
      endTime: '15:00',
    },
  },

  // 变动类型配置
  change: {
    // 巨额赎回
    1: {
      title: '巨额赎回',
      content: '巨额赎回',
      appLink: 'fund://mp.1234567.com.cn/weex/funda310cd172dd395/pages/questionDetail/index?id=794',
      webLink: '',
    },
    // 基金经理变更
    2: {
      title: '经理变更',
      content: '基金经理发生变更',
      appLink: 'fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundManagerList?FCODE={fcode}',
      webLink: '',
    },
    // 基金转型
    // 3: {
    //   title: '转',
    //   content: '基金转型',
    //   appLink: '',
    //   webLink: '',
    // },
    // 基金清盘
    // 4: {
    //   title: '清',
    //   content: '基金清盘',
    //   appLink: '',
    //   webLink: '',
    // },
    // 基金清盘
    6: {
      title: '分红',
      content: '基金分红',
      appLink: 'fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/Index?fundCode={fcode}&index=3&fundName={fname}',
      webLink: '',
    },
  },

};

// 持仓配置
export const hold = {

  // 饼图颜色
  // colors: [
  //   '#FF5272', '#FF965a', '#ffd867', '#71B7FF', '#1F4B9A', '#CD8FFF', '#CCCCCC', '#8B6969',
  //   '#FF5272', '#FF965a', '#ffd867', '#71B7FF', '#1F4B9A', '#CD8FFF', '#CCCCCC', '#8B6969',
  //   '#FF5272', '#FF965a', '#ffd867', '#71B7FF', '#1F4B9A', '#CD8FFF', '#CCCCCC', '#8B6969',
  // ],
  colors: [
    '#3C6DF7', '#4D8EFF', '#7ABDFF', '#7AD8FF', '#8149F7',
    '#926EFD', '#B099FF', '#AF5EBC', '#C77CD3', '#DFA2E9',
    '#C33F5D', '#CB5571', '#FF89A7', '#EA7690', '#F096AB',
    '#FF6933', '#FF8255', '#FE9E7A', '#FE9803', '#FFB515',
    '#FFCD5A', '#FFDD3E', '#BF6735', '#CBBAFF', '#EEA687',
    '#C9937C', '#E6EAF2',
  ],
  // 图表实例集合
  chartList: [
    {
      name: '资产', id: 'canvas_assets', f2: null, track: 'assets',
    },
    {
      name: '行业', id: 'canvas_industry', f2: null, track: 'industry',
    },
  ],

  type: {

    // 普通基金
    normal: {

      // 资产数据类型
      assetList: [
        { name: '基金', key: 'JJ' },
        { name: '股票', key: 'GP' },
        { name: '债券', key: 'ZQ' },
        { name: '现金', key: 'HB' },
        { name: '其他', key: 'QT' },
      ],

      // 资产数据颜色
      assetColor: {
        基金: '#7ABDFF',
        股票: '#FF6933',
        债券: '#FFC94D',
        现金: '#D494FF',
        其他: '#E0E0E0',
      },

    },

    // 货币基金
    hb: {

      // 资产数据类型
      assetList: [
        { name: '债券', key: 'BSPCTNV' },
        { name: '资产支持证券', key: 'ABSPCTNV' },
        { name: '买入返售金融资产', key: 'BREPOPCTNV' },
        { name: '银行存款和结算备付金合计', key: 'MPCTNV' },
        { name: '其他各项资产', key: 'OIPCTNV' },
      ],

      // 资产数据颜色
      assetColor: {
        债券: '#FFC94D',
        资产支持证券: '#4D8EFF',
        买入返售金融资产: '#E6BAFF',
        银行存款和结算备付金合计: '#FF6933',
        其他各项资产: '#E0E0E0',
      },

    },

    // ETF重仓基金
    etf: {

      // 资产数据类型
      assetList: [
        { name: '基金', key: 'JJ' },
        { name: '股票', key: 'GP' },
        { name: '债券', key: 'ZQ' },
        { name: '现金', key: 'HB' },
        { name: '其他', key: 'QT' },
      ],

      // 资产数据颜色
      assetColor: {
        基金: '#7ABDFF',
        股票: '#FF6933',
        债券: '#FFC94D',
        现金: '#D494FF',
        其他: '#E0E0E0',
      },

    },

    // FOF
    fof: {

      // 资产数据类型
      assetList: [
        { name: '基金', key: 'JJ' },
        { name: '股票', key: 'GP' },
        { name: '债券', key: 'ZQ' },
        { name: '现金', key: 'HB' },
        { name: '其他', key: 'QT' },
      ],

      // 资产数据颜色
      assetColor: {
        基金: '#7ABDFF',
        股票: '#FF6933',
        债券: '#FFC94D',
        现金: '#D494FF',
        其他: '#E0E0E0',
      },

    },

  },

};

// 基金规模配置
export const scale = {
  // 图表颜色
  colors: ['#ffc842', '#ffc842', '#ffc842', '#ff5656'],
  // 图表颜色
  colorsGM: [
    ['#ffc842', '#ffc842', '#ffc842', '#ff5656'],
    ['#ff5656'],
    ['#ffc842', '#ff5656'],
    ['#ffc842', '#ffc842', '#ff5656'],
    ['#ffc842', '#ffc842', '#ffc842', '#ff5656'],
  ],
};
